import React, { useMemo } from 'react';
import ChartTableHeader from '../shared/Charts/ChartTableHeaders';
import { TableWithMinWidth } from '../shared/Charts/styles';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import {
  TableRow,
  TableCell,
} from 'components/data-containers/PositionsTable/shared/PositionsTable.style';
import TableBody from 'components/data-visualization/Table/Body';
import Layout from 'components/styled/Layout/Layout';
import BreakdownTablePlaceholder from 'components/data-visualization/Table/BreakdownTablePlaceholder';
import OfficialChartRows from './OfficialChartRows';
import { ProductTypes } from 'types/shared';

interface IOfficialChartsTableProps {
  charts: any[] | undefined;
  isSmallScreen: boolean;
  productType: ProductTypes;
  loading: boolean;
  showProductColumn: boolean;
}

/**
 * Table for the overview official charts, such as 'Spotify Top 200 Weekly'.
 */
const OfficialChartsTable: React.FC<IOfficialChartsTableProps> = (props) => {
  const {
    charts,
    isSmallScreen,
    productType,
    loading,
    showProductColumn,
  } = props;

  const hasData = Boolean(!loading && charts && charts.length);
  const currentColumnCount = useMemo(() => {
    return showProductColumn ? 5 : 4;
  }, [showProductColumn]);

  return (
    <Layout.Relative>
      <TableWithMinWidth wide={showProductColumn}>
        <ChartTableHeader
          isSmallScreen={isSmallScreen}
          showProductColumn={showProductColumn}
          showCustomerColumn={true}
        />
        <TableBody>
          {loading && (
            <TableLoader
              columnCount={currentColumnCount}
              rowComponent={TableRow}
              cellComponent={TableCell}
            />
          )}
          {!loading && hasData && (
            <OfficialChartRows
              charts={charts}
              isSmallScreen={isSmallScreen}
              productType={productType}
              showProductColumn={showProductColumn}
            />
          )}
          {!loading && !hasData && (
            <BreakdownTablePlaceholder
              isSmallScreen={isSmallScreen}
              columnCount={currentColumnCount}
            />
          )}
        </TableBody>
      </TableWithMinWidth>
    </Layout.Relative>
  );
};

export default OfficialChartsTable;
